module.exports = __webpack_public_path__ + "img/ppt.26bcd361.svg";